import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { usePageHeaderVisibility } from './PageHeaderVisibilityContext';
import { useHeaderTitle } from '../header/HeaderTitleContext';

const PageHeader = ({
  title,
  subtitle = '',
  subTitle = '',
  actions = null,
  icon = null,
  sx = {},
}) => {
  const { registerLocalPageHeader } = usePageHeaderVisibility();
  const { setTitle, setSubtitle } = useHeaderTitle();

  useLayoutEffect(() => {
    const unregister = registerLocalPageHeader();
    setTitle(title);
    setSubtitle(subtitle || subTitle || '');
    return unregister;
  }, [registerLocalPageHeader, setTitle, setSubtitle, subtitle, subTitle, title]);

  return null;
};

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  subTitle: PropTypes.string,
  actions: PropTypes.node,
  icon: PropTypes.node,
  sx: PropTypes.object,
};

export default PageHeader;
